export const pointRadius = 3;
export const graphLineWidth = 3;
